$(document).ready(function () {
    var dl = window.shopDataLayer;
    if (!dl || !dl.modal) return;

    function buildNeedHelpHtml(modifier) {
        var d = dl.needHelp;
        var cls = modifier ? "need-help " + modifier : "need-help";
        var now = new Date();
        var mins = now.getHours() * 60 + now.getMinutes();
        var from = d.person.onlineFrom[0] * 60 + d.person.onlineFrom[1];
        var to = d.person.onlineTo[0] * 60 + d.person.onlineTo[1];
        var isOnline = mins >= from && mins < to;
        var statusText = isOnline ? d.person.statusOnline : d.person.statusOffline;
        var statusCls = "need-help__status" + (isOnline ? "" : " need-help__status--offline");
        return (
            "<div class='" + cls + "'>" +
                "<div class='need-help__title'>" + d.title + "</div>" +
                "<div class='need-help__items'>" +
                    "<div class='need-help__item'>" +
                        "<img src='" + d.person.image + "' alt='" + d.person.name + "' class='need-help__avatar'>" +
                        "<div class='need-help__info'>" +
                            "<strong class='need-help__name'>" + d.person.name + "</strong>" +
                            "<span class='" + statusCls + "'><span class='need-help__status-dot'></span>" + statusText + "</span>" +
                        "</div>" +
                    "</div>" +
                    "<div class='need-help__item'>" +
                        "<div class='need-help__icon need-help__icon--phone'></div>" +
                        "<div class='need-help__info'>" +
                            "<a href='" + d.phone.link + "' class='need-help__link'>" + d.phone.number + "</a>" +
                            "<span class='need-help__note'>" + d.phone.hours + "</span>" +
                        "</div>" +
                    "</div>" +
                    "<div class='need-help__item'>" +
                        "<div class='need-help__icon need-help__icon--mail'></div>" +
                        "<div class='need-help__info'>" +
                            "<a href='" + d.email.link + "' class='need-help__link'>" + d.email.address + "</a>" +
                            "<span class='need-help__note'>" + d.email.note + "</span>" +
                        "</div>" +
                    "</div>" +
                "</div>" +
            "</div>"
        );
    }

    function buildSuccess(type) {
        var d = dl.modal[type].success;
        return (
            "<div class='mymodal__success'>" +
                "<h2 class='mymodal__success-title'>" + d.title + "</h2>" +
                "<div class='mymodal__success-text'>" + d.text + "</div>" +
                "<img src='" + d.image + "' alt='' class='mymodal__success-image'>" +
                buildNeedHelpHtml("need-help--inline") +
                "<button class='mymodal__success-btn mymodal__close'>" + d.buttonText + "</button>" +
            "</div>"
        );
    }

    function buildModal(type) {
        var d = dl.modal[type];
        if (!d) return "";
        return (
            "<div class='mymodal' data-modal='" + type + "'>" +
                "<div class='mymodal__overlay'></div>" +
                "<div class='mymodal__content'>" +
                    "<button class='mymodal__close'></button>" +
                    "<div class='mymodal__body'>" +
                        "<div class='mymodal__form-section'>" +
                            "<h2 class='mymodal__title'>" + d.title + "</h2>" +
                            "<p class='mymodal__subtitle'>" + d.subtitle + "</p>" +
                            "<div class='mymodal__form'>" + d.formTag + "</div>" +
                        "</div>" +
                        buildNeedHelpHtml() +
                    "</div>" +
                "</div>" +
            "</div>"
        );
    }

    function openModal(type) {
        $(".mymodal.is-open").removeClass("is-open");

        var $modal = $(".mymodal[data-modal='" + type + "']");
        if (!$modal.length) {
            $(buildModal(type)).appendTo("body");
            $modal = $(".mymodal[data-modal='" + type + "']");
            if (typeof wtFormsInstance !== "undefined") {
                wtFormsInstance.reinit();
            }
        }
        $modal.addClass("is-open");
        $("body").css("overflow", "hidden");
    }

    function closeModal($modal) {
        $modal.removeClass("is-open");
        $("body").css("overflow", "");
    }

    // Close modal
    $(document).on("click", ".mymodal__close, .mymodal__overlay", function () {
        closeModal($(this).closest(".mymodal"));
    });

    $(document).on("keydown", function (e) {
        if (e.key === "Escape") {
            var $open = $(".mymodal.is-open");
            if ($open.length) {
                closeModal($open);
            }
        }
    });

    // Form submit success — replace body with success screen
    document.addEventListener("wtFormSubmitSuccess", function (event) {
        var formId = event.detail ? event.detail.formId : null;
        if (!formId) return;

        var $modal = $(".mymodal.is-open");
        if (!$modal.length) return;

        var type = $modal.attr("data-modal");
        if (!type || !dl.modal[type] || !dl.modal[type].success) return;

        var $wrapper = $modal.find("#wt-form-wrapper-" + formId);
        if (!$wrapper.length) return;

        $modal.find(".mymodal__body").replaceWith(buildSuccess(type));
        $modal.find(".mymodal__content").scrollTop(0);
    });

    // Open rozmer modal from specific-banner
    $(document).on("click", ".specific-banner__button", function (e) {
        e.preventDefault();
        openModal("rozmer");
    });

    // Open firmy modal from header button or any trigger
    $(document).on("click", "[data-modal-open='firmy']", function (e) {
        e.preventDefault();
        openModal("firmy");
    });
});
